import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function FieldReadView({ title, value, spacing = '4px' }) {
  return (
    <Stack spacing={spacing}>
      <Text
        color="primary"
        size="md"
        weight="medium"
      >
        {title}
      </Text>
      <Text
        color="primary"
        size="md"
      >
        {value}
      </Text>
    </Stack>
  );
}

FieldReadView.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  spacing: PropTypes.number
};
